import { RiFileList3Line } from '@remixicon/react';

import LoadingButton from 'src/components/atoms/buttons/LoadingButton';
import { AgModal, AgModalActions, AgModalContent, AgText } from 'src/components/ui';

export default function DeleteExpenseTypeModal({ expenseTypeForDeletion, onClose, onDelete }) {
  return (
    <AgModal open={!!expenseTypeForDeletion} onClose={onClose} title="Delete Expense">
      <AgModalContent>
        <div className="flex flex-col gap-2">
          <AgText>Are you sure you want to delete this expense?</AgText>
          <AgText>{`This action can't be undone.`}</AgText>
          <div className="mt-2 flex h-[152px] w-full flex-col gap-2 rounded border border-neutral-5 p-2">
            <div className="flex items-center gap-1">
              <RiFileList3Line size={20} className="text-brand-6" />
              <AgText size="h6">{expenseTypeForDeletion?.name}</AgText>
            </div>
            <div className="flex items-baseline justify-between gap-2">
              <AgText size="12" className="uppercase tracking-wider" color="secondary">
                Receivable Account
              </AgText>
              <AgText>{expenseTypeForDeletion?.receivablesAccount?.accountName}</AgText>
            </div>
            <div className="flex items-baseline justify-between gap-2">
              <AgText size="12" className="uppercase tracking-wider" color="secondary">
                Payable Account
              </AgText>
              <AgText>{expenseTypeForDeletion?.payablesAccount?.accountName}</AgText>
            </div>
          </div>
        </div>
      </AgModalContent>
      <AgModalActions>
        <LoadingButton
          handleRequest={onDelete}
          handleRequestComplete={onClose}
          variant="white"
          className="bg-red-bg text-red-text border-red-border"
        >
          Delete
        </LoadingButton>
      </AgModalActions>
    </AgModal>
  );
}
